var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-component": "base-agent-info" } }, [
    _c(
      "div",
      { staticClass: "avatar" },
      [
        _c("agent-avatar", {
          attrs: { person: _vm.agent, avatar: _vm.avatar, "data-avatar": "" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "name", attrs: { "data-text": "agent-name" } }, [
      _vm._v("\n    " + _vm._s(_vm.name) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "role", attrs: { "data-text": "agent-role" } }, [
      _vm._v("\n    " + _vm._s(_vm.roleLabel) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }